import { merge, TriangleExclamationIcon } from '@repo/ui'

export function InvalidIcon({ className }: { className?: string }) {
  return <TriangleExclamationIcon className={merge('text-red-500 dark:text-red-500', className)} />
}
